/**
 * Extract the enterprise slug from the current URL path, if present.
 * Returns null when not in an enterprise context.
 */
export function getEnterpriseSlugFromPath(): string | null {
  if (typeof window === "undefined") {
    return null;
  }
  const match = window.location.pathname.match(/^\/enterprise\/([^/]+)/);
  return match ? match[1] : null;
}

/**
 * Returns the API base path for analytics endpoints.
 * In enterprise context (URL contains /enterprise/[slug]), routes to enterprise API.
 * Otherwise, routes to the standard dashboard API.
 */
export function getAnalyticsApiBase(): string {
  const slug = getEnterpriseSlugFromPath();
  if (slug) {
    return `/api/enterprise/${slug}/analytics`;
  }
  return "/api/dashboard/analytics";
}
